<template>
  <div class="authority-badge-customers">
    <div class="authority-badge-customers__icons-wrapper">
      <Icon
        name="custom:badge-solid"
        size="48"
        class="authority-badge-customers__icon-badge"
      />
      <div class="authority-badge-customers__icon-wrapper">
        <Icon
          name="custom:check-solid-full"
          size="20"
          class="authority-badge-customers__icon"
        />
      </div>
    </div>
    <span
      class="authority-badge-customers__text"
      v-html="$t('event_type_example.pre_title')"
    />
  </div>
</template>

<style lang="scss">
  .authority-badge-customers {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .authority-badge-customers__icons-wrapper {
    position: relative;
    color: var(--color-primary);
  }

  .authority-badge-customers__icon-wrapper {
    background: var(--color-secondary);
    width: 60%;
    height: 60%;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .authority-badge-customers__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--color-primary);
  }

  .authority-badge-customers__text {
    background: var(--color-primary);
    padding: 7px 12px 6px 12px;
    position: relative;
    left: -6px;
    border-radius: 0 17px 17px 0;
    font-weight: 300;
    font-size: 14px;
    color: white;
  }
</style>
